/* form-submit-guard.js
   Prevent forms from submitting unless there was an explicit user action
   (click/tap OR Enter/Space) very recently.
*/
(function () {
  'use strict';

  // Track the last explicit user gesture time
  let lastUserGestureAt = 0;
  const GESTURE_WINDOW_MS = 1500; // allow submit within 1.5s of a gesture

  // Record gestures that indicate intent
  function markGesture() {
    lastUserGestureAt = Date.now();
  }

  // "Trusted" user events
  window.addEventListener('pointerdown', markGesture, true);
  window.addEventListener('click', markGesture, true);
  window.addEventListener('keydown', function (e) {
    // Enter/Space commonly indicate intent to submit/activate
    if (e.key === 'Enter' || e.key === ' ') markGesture();
  }, true);

  function hasRecentGesture() {
    return (Date.now() - lastUserGestureAt) <= GESTURE_WINDOW_MS;
  }

  function shouldIgnoreForm(form) {
    if (!form || !(form instanceof HTMLFormElement)) return true;

    // Avoid interfering with Shopify / bot challenge or internal special flows
    const action = (form.getAttribute('action') || '').toLowerCase();

    // Allow Shopify challenge and known platform endpoints (adjust if needed)
    if (form.closest('.shopify-challenge__container')) return true;
    if (action.includes('/challenge')) return true;

    // If you WANT to allow some forms to submit programmatically, mark them:
    // <form data-allow-programmatic-submit="true">
    if (form.dataset && form.dataset.allowProgrammaticSubmit === 'true') return true;

    return false;
  }

  // Intercept normal submit events
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (shouldIgnoreForm(form)) return;

    // If a script tries to submit without an explicit gesture, block it
    if (!hasRecentGesture()) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Optional: focus the first submit button or input so user can proceed
      const submitBtn = form.querySelector('[type="submit"], button:not([type]), button[type="submit"]');
      if (submitBtn) submitBtn.focus({ preventScroll: false });

      // Lightweight, non-intrusive notice (no alert spam)
      console.warn('[Form Submit Guard] Blocked a submit without an explicit user action.', form);
    }
  }, true);

  // Intercept direct programmatic calls: form.submit()
  // Many scripts bypass the submit event by calling form.submit().
  const nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    const form = this;

    if (shouldIgnoreForm(form)) {
      return nativeSubmit.call(form);
    }

    if (!hasRecentGesture()) {
      console.warn('[Form Submit Guard] Blocked programmatic form.submit() without explicit user action.', form);
      return; // block
    }

    return nativeSubmit.call(form);
  };

  // Also guard requestSubmit (newer API that can trigger submit)
  if (HTMLFormElement.prototype.requestSubmit) {
    const nativeRequestSubmit = HTMLFormElement.prototype.requestSubmit;
    HTMLFormElement.prototype.requestSubmit = function (submitter) {
      const form = this;

      if (shouldIgnoreForm(form)) {
        return nativeRequestSubmit.call(form, submitter);
      }

      if (!hasRecentGesture()) {
        console.warn('[Form Submit Guard] Blocked requestSubmit() without explicit user action.', form);
        return;
      }

      return nativeRequestSubmit.call(form, submitter);
    };
  }
})();